import script from "./PageResults.vue?vue&type=script&setup=true&lang=js"
export * from "./PageResults.vue?vue&type=script&setup=true&lang=js"

import "./PageResults.vue?vue&type=style&index=0&id=3e6dfd80&lang=css"

const __exports__ = script;

export default __exports__